import { FullScreenLayout } from 'ui/fullScreen/FullScreenLayout';

import { PreviewPane } from './preview/PreviewPane';
import { DataPane } from '../common/PreviewWithDataDataPane';
import { SettingsDrawer } from '../common/SettingsDrawer';
import {
  EditorContentContainer,
  LayoutContentContainerFullWidth,
  PreviewWithErrorContainer,
} from '../common';
import { ViewFooter } from '../common/ViewFooter';
import { ViewHeader } from '../common/ViewHeader';
import { useTemplateQueryContext } from '../context/TemplateQueryContext';
import { useWebPushPreviewContext } from './context/WebPushPreviewContext';
import { PreviewContentContainer } from '../common/PreviewContentContainer';
import { PreviewWithDataError } from '../common/PreviewWithDataError';

export const TEMPLATE_EDITOR_WEB_PUSH_PREVIEW_W_DATA = 'template-editor-web-push-preview-w-data';

export const PreviewWithDataCore = () => {
  const { onRefreshPreview, previewError } = useWebPushPreviewContext();

  return (
    <EditorContentContainer data-test={TEMPLATE_EDITOR_WEB_PUSH_PREVIEW_W_DATA}>
      <DataPane onRefreshPreview={onRefreshPreview} />
      <PreviewWithErrorContainer>
        {previewError && <PreviewWithDataError previewError={previewError} />}
        <PreviewPane />
      </PreviewWithErrorContainer>
    </EditorContentContainer>
  );
};

export const PreviewWithData = () => {
  const { onRefreshPreview } = useWebPushPreviewContext();
  const { refetch } = useTemplateQueryContext();

  return (
    <FullScreenLayout
      actionBarIsAnchored
      DrawerContent={
        <SettingsDrawer
          onSaveSuccess={() => {
            onRefreshPreview();
            refetch();
          }}
        />
      }
      HeaderContent={<ViewHeader />}
      FooterContent={<ViewFooter />}
    >
      <PreviewContentContainer data-test="template-editor-webpush-preview">
        <LayoutContentContainerFullWidth>
          <PreviewWithDataCore />
        </LayoutContentContainerFullWidth>
      </PreviewContentContainer>
    </FullScreenLayout>
  );
};

export default PreviewWithData;
